import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { AlmanacFile } from 'types'
import { MediaFileMenu } from './MediaFileMenu'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

interface Props extends DrawerProps {
  file: AlmanacFile
}

export const MediaFileMenuDrawer = observer(({ file, ...props }: Props) => {
  const { drawersStore } = useRootStore()
  const close = () => drawersStore.closeDrawer()

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>More Options</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <MediaFileMenu menuType="tray" file={file} close={close} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
